import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { CATEGORY_CODES } from '_constants/categories';
import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';
import { selectCountOfUnread } from '_store/chat/selector';
import { selectCredentialsByCategory } from '_store/credentials/selector';
import { resetData as resetFileTypesData } from '_store/fileTypes/slice';
import { resetMergedFileTypeMapData } from '_store/fileTypes/slice';
import { selectActiveOrderId } from '_store/order/selector';
import { refreshActiveOrderId } from '_store/order/slice';
import { selectOrderOptions } from '_store/orders/selector';
import { resetData as resetStatementsData } from '_store/statements/slice';
import { resetData as resetTasksData, resetFetchCounter as resetTasksFetchCounter } from '_store/tasks/slice';
import { resetForm as resetTaxFilingInfo } from '_store/taxFilingInfo/slice';
import { selectDetails as selectUserDetails } from '_store/user/selector';

import Navbar from './Navbar';

const items = [
  {
    iconAlias: ICON_ALIASES.receipt,
    title: 'Dashboard',
    path: '/main/overview',
  },
  {
    iconAlias: ICON_ALIASES.category,
    title: 'Bookkeeping',
    path: '/main/bookkeeping/overview',
  },
  {
    iconAlias: ICON_ALIASES.moneySend,
    title: 'Tax Preparation',
    path: '/main/tax-preparation/current',
  },
  {
    iconAlias: ICON_ALIASES.message,
    title: 'Chat',
    path: '/main/support',
  },
  // {
  //   iconAlias: ICON_ALIASES.moneyReceive,
  //   title: 'Payroll',
  //   path: '/dashboard/payroll',
  // },
];

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 20;
  background-color: ${theme.colors.indigo.dark};
`;

const StyledInnerContainer = styled.div`
  max-width: ${theme.spaces.large30X * 10}px;
  width: 100%;

  @media ${theme.devices.tablet} {
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
  }
`;

const Header = ({ containerRef }) => {
  const dispatch = useDispatch();
  const credentials = useSelector(selectCredentialsByCategory(CATEGORY_CODES.accounting));
  const userDetails = useSelector(selectUserDetails);
  const activeOrderId = useSelector(selectActiveOrderId);
  const orderOptions = useSelector(selectOrderOptions);
  const countOfUnread = useSelector(selectCountOfUnread);

  const dynamicItems = useMemo(
    () =>
      items.map((item) => {
        if (item.iconAlias === ICON_ALIASES.message) {
          return { ...item, countOfUnread };
        }

        return item;
      }),
    [countOfUnread]
  );

  const handleOrderSelect = (orderId) => {
    dispatch(refreshActiveOrderId(orderId));
    dispatch(resetTaxFilingInfo());
    dispatch(resetStatementsData());
    dispatch(resetTasksData());
    dispatch(resetTasksFetchCounter());
    dispatch(resetFileTypesData());
    dispatch(resetMergedFileTypeMapData());
  };

  return (
    <StyledOuterContainer ref={containerRef}>
      <StyledInnerContainer>
        <Navbar
          items={dynamicItems}
          userDetails={{ ...userDetails, monexaUsername: credentials?.username }}
          activeOrderId={activeOrderId}
          orderOptions={orderOptions}
          onOrderSelect={handleOrderSelect}
        />
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

Header.propTypes = {
  containerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

export default Header;
